import { createContext, useContext, useReducer } from "react";

const AppGlobalContext = createContext(null);

const initState = {
    goftinoIsReady: false,
    isGoftinoOpen: false,
    supportUserIsSynced: false,
    goftinoSendMessageCounter: null,
    goftinoGetMessageCounter: null,
};

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_GOFTINO_IS_READY":
            return {
                ...state,
                goftinoIsReady: true,
            };
        case "TOGGLE_GOFTINO_OPEN":
            return {
                ...state,
                isGoftinoOpen: true,
            };
        case "TOGGLE_GOFTINO_CLOSE":
            return {
                ...state,
                isGoftinoOpen: false,
            };
        case "SET_SUPPORT_USER_IS_SYNCED":
            return {
                ...state,
                supportUserIsSynced: true,
            };
        case "SET_GOFTINO_SEND_MESSAGE_COUNTER":
            return {
                ...state,
                goftinoSendMessageCounter: state.goftinoSendMessageCounter + 1,
            };
        case "SET_GOFTINO_GET_MESSAGE_COUNTER":
        default:
            return {
                ...state,
                goftinoGetMessageCounter: state.goftinoGetMessageCounter + 1,
            };
    }
};

export function AppGlobalProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, initState);

    return (
        <AppGlobalContext.Provider value={[state, dispatch]}>
            {children}
        </AppGlobalContext.Provider>
    );
}

export function useAppGlobal() {
    const [state, dispatch] = useContext(AppGlobalContext);

    return {
        isGoftinoReady: state.goftinoIsReady,
        isGoftinoOpen: state.isGoftinoOpen,
        isSupportUserSynced: state.supportUserIsSynced,
        goftinoSendMessageCounter: state.goftinoSendMessageCounter,
        goftinoGetMessageCounter: state.goftinoGetMessageCounter,
        setGoftinoIsReady: () => {
            dispatch({ type: "SET_GOFTINO_IS_READY" });
        },
        toggleGoftinoOpen: () => {
            dispatch({ type: "TOGGLE_GOFTINO_OPEN" });
        },
        toggleGoftinoClose: () => {
            dispatch({ type: "TOGGLE_GOFTINO_CLOSE" });
        },
        setSupportUserIsSynced: () => {
            dispatch({ type: "SET_SUPPORT_USER_IS_SYNCED" });
        },
        goftinoSendMessageOcurred: () => {
            dispatch({
                type: "SET_GOFTINO_SEND_MESSAGE_COUNTER",
            });
        },
        goftinoGetMessageOcurred: () => {
            dispatch({
                type: "SET_GOFTINO_GET_MESSAGE_COUNTER",
            });
        },
    };
}
